/**
 * Open a popup with the given HTML document and trigger its print dialog.
 *
 * Returns false when the popup was blocked (callers must surface feedback —
 * a silently dead button reads as broken). Printing waits for the document's
 * load event (remote fonts/styles) with a timer fallback, and never calls
 * print() on a window the user already closed.
 */
export function openPrintWindow(html) {
  if (!html) return false;
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  if (!printWindow) return false;

  printWindow.document.write(html);
  printWindow.document.close();

  let printed = false;
  const printOnce = () => {
    if (printed) return;
    printed = true;
    try {
      if (!printWindow.closed) printWindow.print();
    } catch {
      /* window closed between the check and the call — nothing to do */
    }
  };

  try {
    printWindow.addEventListener('load', () => setTimeout(printOnce, 150));
  } catch {
    /* some browsers restrict listener access on popups — timer still fires */
  }
  setTimeout(printOnce, 1500);
  return true;
}
